import React, { Component } from "react";
import { PureComponent } from "react";
import {
  isPlayerInTeam,
  isPlayerInBench,
  isCaptain,
  canPlayerSubstitute,
  isPlayerInRecover,
} from "./helper";
import {
  showLoader,
  customTracking,
  getLoginCookie,
  setLocalStorage,
  makeManageTeamSkeleton,
  getBoosterCaptain,
} from "../../common";
import config from "../../common/config";
import apiErrors from "../../common/api-errors";

import {
  makeCaptain,
  hideLoader,
  doseCaptainHasPoints,
} from "../../common/index";
import { Consume } from "../../Context/Consumer";
import {
  ShowPopUpContext,
  TeamDataContext,
  CompositionContext,
  ConstraintsContext,
  GamedaysContext,
  ShowToastContext,
  PlayerListContext,
  PlayerCardContext,
  FixturesContext,
} from "../../Context";
import { Fragment } from "react";

class PlayerAction extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
    };
  }

  addRemovePlayer = (player, teamdata, playerIndex, screenMode) => {
    this.props.close();
    if (screenMode == config.screenMode["create-team"]) {
      this.props.addRemPly(
        player.details,
        this.props.TeamData.manageTeamRawData,
        playerIndex
      );
    } else {
      this.props.TeamData.addRemovePlayer(
        player.details,
        this.props.TeamData.manageTeamRawData
      );
    }
  };

  changeCaptaintoWithoutPts = (teamData, player, teamDataActions) => {
    let getTrans = this.props.getTrans;
    let trans = this.props.trans;
    hideLoader();
    if (doseCaptainHasPoints(teamData)) {
      //show captain change warning
      this.props.setShowWarning(true);
    } else {
      this.props.close();
      customTracking(
        "Captain - Player Card",
        "/" + config.GAME_NAME + "/my-team/manage/"
      );
      showLoader();
      this.props.specificData.makeCaptain(player);
    }
  };

  makeCaptainHelper = (player) => {
    const loginCookie = getLoginCookie();
    const {
      TeamData,
      CompositionData,
      ConstraintsData,
      Gamedays,
      PlayerListData,
      getTrans,
      ShowToast,
      teamData: teamDataParent,
      showHideToast,
      close,
      trans,
      FixturesData,
    } = this.props;

    const { makePostCaptain } = TeamData;

    let paramsCap = {
      optType: config.optType,
      platform: 1,
      gamedayId: FixturesData.currMatchDay.GamedayId,
      phaseId: FixturesData.currMatchDay.PhaseId,
      teamName: loginCookie.TeamName,
      captainId: player.id,
      gdCompId:
        CompositionData.data[config.WebConfig.MAX_FORMATION_COMP_ID].CompId,
      mdCompId: teamDataParent.CompId,
      bsCaptainId: teamDataParent.boosterCaptainId,
    };
    makePostCaptain(
      paramsCap,
      (resp) => {
        close();
        showHideToast(
          true,
          getTrans(trans, "cptChange", "captain change successfull"),
          false
        );

        let params = {
          optType: config.optType,
          gamedayId: FixturesData.currMatchDay.GamedayId,
          phaseId: FixturesData.currMatchDay.PhaseId,
          language: config.language,
        };
        Gamedays.getSelectedTeam(
          params,
          (response) => {
            let teamDataSkeleton = makeManageTeamSkeleton(
              response.Data.Value,
              PlayerListData.rawPlayerList,
              CompositionData.data
            );
            TeamData.setTeamData({
              ...teamDataSkeleton.teamData,
            });
            setLocalStorage("teamData", teamDataSkeleton.teamData);
          },
          () => {}
        );
      },
      (resp) => {
        close();

        if (resp) {
          let retVal = resp.RetVal;
          let success = resp.Success;

          console.log(retVal);
          console.log({ msg: apiErrors.captainChange[retVal] });
          if (!success) {
            showHideToast(true, apiErrors.captainChange[retVal], false);
          } else {
            // self.showHideToast(true, `retVal Error ${retVal}`, true);
            // self.resetTeam(true);
          }
        }
      }
    );
  };

  render() {
    let {
      teamData,
      player,
      compositions,
      playerIndex,
      getTrans,
      trans,
      playerActions,
      specificData,
      mode,
      teamDataPlayer,
      config,
      teamDataActions,
      PlayerCardData,
    } = this.props;

    const { makeCaptainHelper } = this;

    //check if player in team
    let viewSkillButton,
      buttonsMarkUp,
      addPlayerMarkUp,
      removePlayerMarkUp,
      makeCaptMarkUp,
      transfersMarkup,
      recoverMarkup,
      subsMarkup,
      cancelSubsMarkup,
      makeSubsMarkup = null;
    let screenMode = this.props.screenMode;

    let ID = player.id;

    let isPlayInTeam = isPlayerInTeam(
      ID,
      screenMode == config.screenMode["create-team"] ? teamData.data : teamData
    );
    let isPlayInBench = isPlayerInBench(ID, teamData);
    let isPlayCaptain = isCaptain(ID, teamData);
    let isPlayBoosterCaptain =
      getBoosterCaptain(teamData)?.id === ID ? true : false;

    let isPlayerRemoved = false;

    let subsClickHandler = {};

    let addRemPlayerClick = {};

    if (playerActions) {
      addRemPlayerClick = {
        onClick: () => {},
      };
    }

    let gameMode = this.props.mode;
    let actionButtonMarkup = null;

    if (
      gameMode == config.modes.transfer &&
      screenMode == config.screenMode["view-manage-team"]
    ) {
      if (isPlayInTeam) {
        if (!isPlayCaptain && !isPlayInBench && !isPlayBoosterCaptain) {
          makeCaptMarkUp = (
            <div
              onClick={(e) => {
                e.preventDefault();
                makeCaptainHelper(player);
              }}
              className="si-btn si-btn__secondary si-btn__secondary--outline"
            >
              <span>{getTrans(trans, "makCapt", "Make captain")}</span>
            </div>
          );
        }

        let makeTransfers = {
          onClick: () => {
            this.props.close();
            customTracking(
              "Start Transfers - Player Card",
              "/" + config.GAME_NAME + "/my-team/manage/"
            );
            this.props.specificData.goToSpecificPath(player, {}, playerIndex);
          },
        };
        transfersMarkup = (
          <div className="si-plyr__action-item" {...makeTransfers}>
            <div className="si-icon euro-transfer si-bg--error"></div>
            <div className="si-plyr__action-txt">
              {getTrans(trans, "transfersPlyaction", "Transfers")}
            </div>
          </div>
        );
        let makeSubstitutionInit = {
          onClick: () => {
            this.props.specificData.initiateSubs(player);
          },
        };
        subsMarkup = (
          <div {...makeSubstitutionInit} className="si-btn si-btn__primary">
            <span>
              {isPlayInBench
                ? getTrans(trans, "subsIn", "Substitute In")
                : getTrans(trans, "subsOut", "Substitute Out")}
            </span>
          </div>
        );
      }
      actionButtonMarkup = (
        <React.Fragment>
          {subsMarkup}
          {teamDataPlayer?.DBDetails?.IsPlayed === 0 && makeCaptMarkUp}
          {/* {transfersMarkup} */}
        </React.Fragment>
      );
    }

    // during transfer or create team
    if (
      (gameMode == config.modes.transfer &&
        screenMode == config.screenMode.transfer) ||
      (gameMode == config.modes.transfer &&
        screenMode == config.screenMode["create-team"])
    ) {
      if (screenMode == config.screenMode.transfer) {
      }
      // if (isPlayInTeam) {
      makeCaptMarkUp = (
        <div
          onClick={(e) => {
            e.preventDefault();

            this.addRemovePlayer(
              player,
              PlayerCardData?.playerObjKey,
              playerIndex,
              screenMode
            );
          }}
          className="si-btn si-btn__secondary si-btn__secondary--outline"
        >
          <span>
            {getTrans(
              trans,
              screenMode == config.screenMode["create-team"]
                ? isPlayInTeam
                  ? "removePlayer"
                  : "addPlayer"
                : isPlayInTeam
                ? "transOut"
                : "transIn",
              screenMode == config.screenMode["create-team"]
                ? isPlayInTeam
                  ? "Remove Player "
                  : "Add Player"
                : isPlayInTeam
                ? "Transfer Out"
                : "Transfer In"
            )}
          </span>
        </div>
      );
      // } else {
      //   makeCaptMarkUp = (
      //     <div
      //       onClick={(e) => {
      //         e.preventDefault();
      //         // makeCaptainHelper(player);
      //       }}
      //       className="si-btn si-btn__primary "
      //     >
      //       <span>{getTrans(trans, "addPlayer", "Add Player")}</span>
      //     </div>
      //   );
      // }
      actionButtonMarkup = (
        <React.Fragment>
          {/* {subsMarkup} */}
          {makeCaptMarkUp}
          {/* {transfersMarkup} */}
        </React.Fragment>
      );
    }
    //whn modes is substitution and let it be viewmanage team or subs scenario
    if (gameMode == config.modes.substitution) {
      let canPlayerBeSubstituted = canPlayerSubstitute(teamDataPlayer);
      let isDisabled = !canPlayerBeSubstituted;
      let isCaptainDisabled = false;
      let dontShowCaptain = false;
      if (teamDataPlayer.DBDetails.IsPlayed) {
        isCaptainDisabled = true;
      }

      if (
        screenMode == config.screenMode["view-manage-team"] &&
        !isPlayInBench &&
        !isPlayCaptain
      ) {
        dontShowCaptain = true;
      }
      if (teamDataPlayer.toBeSubstituted) {
        //show cancel subs
        subsClickHandler = {
          onClick: () => {
            this.props.close();
            teamDataActions.makeSubstitution(teamDataPlayer, compositions);
          },
        };
        if (!canPlayerBeSubstituted) {
          subsClickHandler = {
            onClick: () => {},
          };
        }

        subsMarkup = (
          <React.Fragment>
            <div
              className={
                isDisabled
                  ? "si-btn si-btn__primary si-disabled"
                  : "si-btn si-btn__primary"
              }
              {...subsClickHandler}
            >
              <span>
                {getTrans(trans, "cancelSubs", "Cancel Substitution")}
              </span>
            </div>
          </React.Fragment>
        );
      } else if (isPlayInBench) {
        //subs in
        subsClickHandler = {
          onClick: () => {
            this.props.close();
            if (screenMode == config.screenMode["view-manage-team"]) {
              this.props.specificData.initiateSubs(player);
            } else {
              if (teamDataPlayer.couldBeUsedToReplace) {
                customTracking(
                  "Substitute - Player Card",
                  "/" + config.GAME_NAME + "/my-team/substitutions/"
                );
                teamDataActions.makeSubstitution(teamDataPlayer, compositions);
              } else {
                teamDataActions.initiateSubstitution(teamData, teamDataPlayer);
              }
            }
          },
        };
        if (!canPlayerBeSubstituted) {
          subsClickHandler = {
            onClick: () => {},
          };
        }
        //added for captain chnage
        let makeCaptainInsubs = {
          onClick: () => {
            if (!isPlayCaptain && !isPlayInBench && !isCaptainDisabled) {
              this.changeCaptaintoWithoutPts(
                teamData,
                player,
                teamDataActions,
                getTrans
              );
            }
          },
        };

        subsMarkup = (
          <>
            <div
              className={
                isDisabled
                  ? "si-btn si-btn__primary si-disabled"
                  : "si-btn si-btn__primary"
              }
              {...subsClickHandler}
            >
              <span>
                {isPlayInBench
                  ? getTrans(trans, "SubsIn", "Substitute In")
                  : getTrans(trans, "SubsOut", "Substitute Out")}
              </span>
            </div>
            {!dontShowCaptain &&
            !isPlayCaptain &&
            !isPlayInBench &&
            !isPlayBoosterCaptain &&
            teamDataPlayer.DBDetails.IsPlayed === 0 ? (
              <div
                {...makeCaptainInsubs}
                className={
                  isDisabled || isCaptainDisabled
                    ? "si-btn si-btn__secondary si-btn__secondary--outline si-disabled"
                    : "si-btn si-btn__secondary si-btn__secondary--outline"
                }
              >
                <span>{getTrans(trans, "makCapt", "make captain")}</span>
              </div>
            ) : null}
          </>
        );
        if (
          teamData.substitutionInitiated &&
          teamData.IsBenchSubstitution &&
          !teamDataPlayer.toBeSubstituted
        ) {
          //switch order
          //subs in
          subsClickHandler = {
            onClick: () => {
              this.props.close();
              if (teamDataPlayer.couldBeUsedToReplace) {
                teamDataActions.makeSubstitution(teamDataPlayer, compositions);
              } else {
                teamDataActions.initiateSubstitution(teamData, teamDataPlayer);
              }
            },
          };
          if (!canPlayerBeSubstituted) {
            subsClickHandler = {
              onClick: () => {},
            };
          }
          subsMarkup = (
            <div
              className={
                isDisabled
                  ? "si-btn si-btn__primary si-disabled"
                  : "si-btn si-btn__primary"
              }
              {...subsClickHandler}
            >
              <span>{getTrans(trans, "switchorder", "switch order")}</span>
            </div>
          );
        }
      } else {
        subsClickHandler = {
          onClick: () => {
            this.props.close();
            if (screenMode == config.screenMode["view-manage-team"]) {
              this.props.specificData.initiateSubs(player);
            } else {
              if (teamDataPlayer.couldBeUsedToReplace) {
                customTracking(
                  "Substitute - Player Card",
                  "/" + config.GAME_NAME + "/my-team/substitutions/"
                );
                teamDataActions.makeSubstitution(teamDataPlayer, compositions);
              } else {
                teamDataActions.initiateSubstitution(teamData, teamDataPlayer);
              }
            }
          },
        };
        if (!canPlayerBeSubstituted) {
          subsClickHandler = {
            onClick: () => {},
          };
        }

        //added for captain chnage
        let makeCaptainInsubs = {
          onClick: () => {
            if (!isPlayCaptain && !isPlayInBench && !isCaptainDisabled) {
              this.changeCaptaintoWithoutPts(
                teamData,
                player,
                teamDataActions,
                getTrans
              );
            }
          },
        };

        subsMarkup = (
          <>
            <div
              className={
                isDisabled
                  ? "si-btn si-btn__primary si-disabled"
                  : "si-btn si-btn__primary"
              }
              {...subsClickHandler}
            >
              <span>
                {isPlayInBench
                  ? getTrans(trans, "SubsIn", "Substitute In")
                  : getTrans(trans, "SubsOut", "Substitute Out")}
              </span>
            </div>
            {!dontShowCaptain &&
            !isPlayCaptain &&
            !isPlayInBench &&
            !isPlayBoosterCaptain &&
            teamDataPlayer.DBDetails.IsPlayed === 0 ? (
              <div
                {...makeCaptainInsubs}
                className={
                  isDisabled || isCaptainDisabled
                    ? "si-btn si-btn__secondary si-btn__secondary--outline si-disabled"
                    : "si-btn si-btn__secondary si-btn__secondary--outline"
                }
              >
                <span>{getTrans(trans, "makCapt", "make captain")}</span>
              </div>
            ) : null}
          </>
        );
      }
      //only for captain selection
      if (
        screenMode == config.screenMode["view-manage-team"] &&
        !isPlayInBench &&
        !isPlayCaptain
      ) {
        let isCaptainDisabled = false;
        if (teamDataPlayer.DBDetails.IsPlayed) {
          isCaptainDisabled = true;
        }
        let makeCaptain = {
          onClick: () => {
            if (!isCaptainDisabled) {
              if (gameMode === config.modes.substitution) {
                this.changeCaptaintoWithoutPts(
                  teamData,
                  player,
                  teamDataActions
                );
              } else {
                this.props.close();
                customTracking(
                  "Captain - Player Card",
                  "/" + config.GAME_NAME + "/my-team/manage/"
                );
                showLoader();
                this.props.specificData.makeCaptain(player);
              }
            }
          },
        };
        makeCaptMarkUp = (
          <div
            className={
              isCaptainDisabled
                ? "si-btn si-btn__secondary si-btn__secondary--outline si-disabled"
                : "si-btn si-btn__secondary si-btn__secondary--outline"
            }
            {...makeCaptain}
          >
            <span>{getTrans(trans, "makCapt", "make captain")}</span>
          </div>
        );
      }

      actionButtonMarkup = (
        <React.Fragment>
          {subsMarkup}
          {teamDataPlayer.DBDetails.IsPlayed === 0 && makeCaptMarkUp}
        </React.Fragment>
      );
    } else if (mode === config.modes.transfer || player?.isBench) {
      makeCaptMarkUp = <Fragment />;
    }

    let mainMarkup = actionButtonMarkup;

    if (mainMarkup && !specificData.hideButton) {
      return <>{mainMarkup}</>;
    } else {
      return null;
    }
  }
}
export default Consume(PlayerAction, [
  ShowPopUpContext,
  TeamDataContext,
  CompositionContext,
  ConstraintsContext,
  GamedaysContext,
  ShowToastContext,
  PlayerListContext,
  PlayerCardContext,
  FixturesContext,
]);
